import { render, staticRenderFns } from "./LoaderPayment.vue?vue&type=template&id=026afd95&scoped=true"
import script from "./LoaderPayment.vue?vue&type=script&lang=js"
export * from "./LoaderPayment.vue?vue&type=script&lang=js"
import style0 from "./LoaderPayment.vue?vue&type=style&index=0&id=026afd95&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026afd95",
  null
  
)

export default component.exports